export function post<T>(path: string, obj?: unknown) {
  return _fetch<T>('POST', path, obj);
}

export function get<T>(path: string, authenticated = true) {
  return _fetch<T>('GET', path, null, authenticated);
}

class FetchError extends Error {
  constructor(
    public statusCode: number,
    message?: string | undefined,
  ) {
    super(message);

    // This trick is necessary to extend a native type from a transpiled ES6 class.
    Object.setPrototypeOf(this, FetchError.prototype);
  }
}

async function _fetch<T = unknown>(method: string, path: string, json: unknown, authenticated = true): Promise<T> {
  const headers = new Headers();

  if (json) {
    headers.set('Content-Type', 'application/json');
  }

  const response = await fetch(_getUrl(path), {
    headers,
    method,
    credentials: 'include',
    ...(json ? { body: JSON.stringify(json, null, 2) } : {}),
  });

  if (!response.ok) {
    const err = new FetchError(response.status, `Response ${response.status} for ${path}`);
    err.message = await response.text();
    throw err;
  }
  const contentType = response.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) {
    return response.json();
  } else if (!response.bodyUsed) {
    /** @ts-expect-error TODO write something meaning ful here about why this error is being ignored */
    return response.statusText;
  }
  throw new Error(`Unexpected content-type for ${path}`);
}

function _getUrl(path: string) {
  return `${globalThis.ENV.INSOMNIA_API_URI}${path}`;
}
